import { t } from '@/plugins/i18n'
import { isD2C, getCustomerShopPlatform } from '@/store'
export const editableTabs = [
  {
    title: t('未下单'),
    name: '0'
  },
  {
    title: t('已下单'),
    name: '1'
  }
]

export const columns = [
  {
    label: t('店铺订单号'),
    prop: 'shopOrderNo',
    slotName: 'shopOrderNo',
    width: 200
  },
  {
    label: t('订单') + `（${getCustomerShopPlatform()}）`,
    prop: 'orderName',
    width: 200
  },
  {
    label: t('订单时间'),
    prop: 'shopOrderTime',
    align: 'center',
    slotName: 'shopOrderTime'
  },
  {
    label: t('采购状态'),
    prop: 'orderSyncStatus',
    align: 'center',
    width: 220,
    slotName: 'orderSyncStatus'
  },
  {
    label: t('订单金额'),
    prop: 'shopOrderAmount',
    align: 'center',
    slotName: 'shopOrderAmount'
  },
  {
    label: t('商品数量'),
    prop: 'quantity',
    slotName: 'quantity',
    align: 'center'
  },
  {
    label: t('收货信息'),
    prop: 'receiver',
    align: 'center',
    width: 200,
    slotName: 'receiver'
  },
  {
    label: t('国际物流配置'),
    prop: 'intShipConfigId',
    align: 'center',
    width: 280,
    slotName: 'intShipConfigId',
    slotHeadName: 'intShipConfigIdHead'
  },
  {
    label: t('追跡番号自動反映'),
    prop: 'isReturnLogisticsNo',
    align: 'center',
    width: 200,
    slotName: 'isReturnLogisticsNo'
  },
  {
    label: t('中国发货附加项'),
    prop: 'deliveryAdditionalList',
    align: 'center',
    width: 200,
    slotName: 'deliveryAdditionalList'
  },
  {
    label: t('韩国发货附加项'),
    prop: 'deliveryAdditionalList2',
    align: 'center',
    width: 200,
    slotName: 'deliveryAdditionalList2'
  },
  {
    label: t('日本发货附加项'),
    prop: 'deliveryAdditionalList3',
    align: 'center',
    width: 200,
    slotName: 'deliveryAdditionalList3'
  }
]
export const columnsed = [
  {
    label: t('店铺订单号'),
    prop: 'shopOrderNo',
    slotName: 'shopOrderNo',
    width: 200
  },
  {
    label: t('订单') + `（${getCustomerShopPlatform()}）`,
    prop: 'orderName',
    width: 200
  },
  {
    label: t('订单状态'),
    prop: 'orderStatus',
    align: 'center',
    slotName: 'orderStatus',
    hidden: ['1']
  },
  {
    label: t('订单时间'),
    prop: 'shopOrderTime',
    align: 'center',
    slotName: 'shopOrderTime'
  },
  {
    label: t('采购状态'),
    prop: 'orderSyncStatus',
    align: 'center',
    width: 200,
    slotName: 'orderSyncStatus',
    hidden: ['2', '3']
  },
  {
    label: t('订单金额'),
    prop: 'shopOrderAmount',
    align: 'center',
    slotName: 'shopOrderAmount'
  },
  {
    label: t('商品数量'),
    prop: 'quantity',
    slotName: 'quantity',
    align: 'center',
    hidden: ['2', '3']
  },
  {
    label: t('收货信息'),
    prop: 'receiver',
    align: 'center',
    width: 200,
    slotName: 'receiver'
  },
  {
    label: t('中国发货附加项'),
    prop: 'deliveryAdditionalList',
    align: 'center',
    width: 200,
    slotName: 'deliveryAdditionalList',
    hidden: ['2', '3']
  },
  {
    label: t('韩国发货附加项'),
    prop: 'deliveryAdditionalList2',
    align: 'center',
    width: 200,
    slotName: 'deliveryAdditionalList2',
    hidden: ['2', '3']
  },
  {
    label: t('日本发货附加项'),
    prop: 'deliveryAdditionalList3',
    align: 'center',
    width: 200,
    slotName: 'deliveryAdditionalList3',
    hidden: ['2', '3']
  }
]
export const shopOrderPurchaseStatusDict: any = {
  0: t('未下单'),
  1: t('已下单')
}

export const tableConfig = {
  showSelection: true,
  showHandler: true,
  showExpand: true,
  rowKey: 'shopOrderId',
  setHeight: true,
  selectable: (row: any) => row.placeOrder,
  handlerConfig: { label: ' ' }
}

export const childColumns = [
  {
    label: t('商品图'),
    prop: 'shoppingInfo',
    slotName: 'shoppingInfo',
    width: 200
  },
  {
    label: t('SKU规格'),
    prop: 'shopProductInfo',
    align: 'center',
    slotName: 'shopProductInfo'
  },
  {
    label: t('客户商品sku'),
    prop: 'itemRemark',
    align: 'center',
    slotName: 'itemRemark'
  },
  {
    label: t('关联状态'),
    prop: 'bindStatus',
    align: 'center',
    slotName: 'bindStatus'
  },
  {
    label: t('商品采购国家'),
    prop: 'purchaseCountry',
    align: 'center',
    slotName: 'purchaseCountry'
  },
  {
    label: t('商品数量'),
    prop: 'itemQuantity',
    align: 'center',
    slotName: 'itemQuantity'
  },
  {
    label: t('采购链接sku'),
    prop: 'shopProductSkuDetail',
    slotName: 'shopProductSkuDetail',
    width: 200,
    align: 'center'
  },
  {
    label: t('商品附加项'),
    prop: 'addition',
    align: 'center',
    width: 120,
    slotName: 'addition'
  }
]
// 待补货商品表头
export const replenishChildColumns = [
  {
    label: t('商品图'),
    prop: 'shoppingInfo',
    slotName: 'shoppingInfo',
    width: 200
  },
  {
    label: t('SKU规格'),
    prop: 'shopProductInfo',
    align: 'center',
    slotName: 'shopProductInfo'
  },
  {
    label: t('客户商品sku'),
    prop: 'itemRemark',
    align: 'center',
    slotName: 'itemRemark'
  },
  {
    label: t('关联状态'),
    prop: 'bindStatus',
    align: 'center',
    slotName: 'bindStatus'
  },
  // {
  //   label: t('国家'),
  //   prop: 'productCountry',
  //   align: 'center',
  //   slotName: 'productCountry'
  // },
  {
    label: t('商品状态'),
    prop: 'goodsStatus',
    align: 'center',
    slotName: 'goodsStatus'
  },
  {
    label: t('采购链接sku'),
    prop: 'shopProductSkuDetail',
    slotName: 'shopProductSkuDetail2',
    width: 350,
    align: 'center'
  },
]

export const comChildColumns = [
  {
    label: t('商品图'),
    prop: 'productSkuImg',
    slotName: 'productSkuImg',
    width: 100
  },
  {
    label: t('商品名称'),
    slotName: 'productTitleJp',
    prop: 'productTitleJp'
  },
  {
    label: t('SKU规格'),
    prop: 'productPropertiesName',
    slotName: 'productPropertiesName',
    align: 'center'
  },
  {
    label: t('THE CKB SKU'),
    prop: 'productSku',
    slotName: 'productSku',
    align: 'center',
    width: 200
  },
  {
    label: t('単品数量'),
    prop: 'unitNums',
    slotName: 'unitNums',
    align: 'center',
    width: 120
  },
  {
    label: t('商品附加项'),
    prop: 'additionList',
    align: 'center',
    slotName: 'additionList'
  }
]

export const replenishComChildColumns = [
  {
    label: t('商品图'),
    prop: 'productSkuImg',
    slotName: 'productSkuImg',
    width: 100
  },
  {
    label: t('商品名称'),
    slotName: 'productTitleJp',
    prop: 'productTitleJp'
  },
  {
    label: t('SKU规格'),
    prop: 'productPropertiesName',
    slotName: 'productPropertiesName',
    align: 'center'
  },
  {
    label: t('THE CKB SKU'),
    prop: 'productSku',
    slotName: 'productSku',
    align: 'center',
    width: 200
  },
  {
    label: t('商品状态'),
    prop: 'goodsStatus',
    align: 'center',
    slotName: 'goodsStatus'
  },
]
export const childConfig = {
  showHandler: true,
  rowKey: 'shopOrderItemId',
  showExpand: true,
  handlerConfig: { label: ' ' },
  expandConfigId: 'isCom',
  dataFormatFn: (data: any) => {
    return data.map((i: any) => {
      return {
        ...i,
        isCom: i?.platformItemSku?.productType === 3 ? '1' : ''
      }
    })
  }
}
export const comConfig = {
  rowKey: 'productSku'
}
export const combinConfig = {
  showHandler: false,
  showExpand: true,
  rowKey: 'shopOrderItemId',
  expandConfigId: 'combinationOrderItemList',
  handlerConfig: { label: ' ', minWidth: 0, fixed: false }
}
export const childApiConfig = {
  listPath: 'data'
}

export const shopProductSkuBindStatusDict: any = {
  0: t('未关联'),
  1: t('已关联'),
  2: t('关联异常')
}

export const getAreaTxt = (
  row: { shopOrderProvince: any },
  provinces: any[]
) => {
  const t: any = (provinces || []).find(
    (e: any) => String(e.intAreaId) === String(row.shopOrderProvince)
  )
  return t?.label ?? row?.shopOrderProvince ?? ''
}

export const getCityTxt = (
  row: { shopOrderProvince: any; shopOrderCity: any },
  provinces: any[]
) => {
  const t: any = (provinces || []).find(
    (e: any) => String(e.intAreaId) === String(row.shopOrderProvince)
  )
  if (t) {
    const v = t.children.find(
      (e: any) => String(e.intAreaId) === String(row.shopOrderCity)
    )
    return v?.label ?? row?.shopOrderCity ?? ''
  } else {
    return row?.shopOrderCity ?? ''
  }
}

export const setAreaTxt = (
  row: { shopOrderProvince: any },
  provinces: any[]
) => {
  const t: any = (provinces || []).find(
    (e: any) => e.label === row.shopOrderProvince
  )
  return t?.intAreaId ?? row?.shopOrderProvince ?? ''
}

export const setCityTxt = (
  row: { shopOrderProvince: any; shopOrderCity: any },
  provinces: any[]
) => {
  const t: any = (provinces || []).find(
    (e: any) => e.label === row.shopOrderProvince
  )
  if (t) {
    const v = t.children.find((e: any) => e.label === row.shopOrderCity)
    return v?.intAreaId ?? row?.shopOrderCity ?? ''
  } else {
    return row?.shopOrderCity ?? ''
  }
}

export const adverseRisk = `
  ご注文の際に検品オプションを選択頂いた場合、当社の検品標準により検品を行います。
  不良品と判断される場合、ご指定頂いた不良品の対応方式に従って「返品返金」OR 「交換」を行います。
  但し、当社で不良品と判断されたものの、販売サイトまたはショップに対して返品できないため返品不可になる場合がありますので予めご了承下さい。
  （発生確率が約0~0.1%程度）

  その場合、当該不良品が返品不可不良品となります。

  返品不可不良品に対して、【在庫管理】メニュー で廃棄処理を依頼するか、
  お客様の許可を得た上で、良品としてお客様に配送するか、
  いずれかの処理方法を選択することができます。

  当社で廃棄処理を依頼する場合、お客様において当該商品の所有権が放棄されたものとみなし、ショップから商品代金の返金はなされませんので予めご了承ください。

  ※以下のいずれかに該当する場合は返品不可不良品となる可能性があります。
  ・お客様の検品要求が常に厳しく、ショップ側が不良品と認められない場合
  ・ショップ側は7日間無条件返品サービスを提供してない場合
  ・お客様都合により返品受付期間内（商品到着後7日以内）に返品要求を提出してない場合※返品不可不良品の発生を回避する方法については、下記の内容をご参照下さい。
  ${isD2C()
    ? 'https://s.theckb.com/d2c/article/2/78'
    : 'https://s.theckb.com/b2b/article/2/78'
  }
`

/** 一键下单在途库存的column */
export const stockOneclickColumns: any = [
  {
    label: t('商品信息'),
    prop: 'productSkuImg',
    align: 'center',
    slotName: 'productSkuImg',
    width: 280
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center'
    // width: 120
  },

  // {
  //   label: t('购买数'),
  //   prop: 'skuOrderNum',
  //   align: 'center'
  //   // width: 120
  // },
  {
    label: t('处理中库存使用数'),
    prop: 'onTheWayAvailableNum',
    align: 'center'
    // width: 120
  }
]

export const tableConfigStockOneclick = {
  showSelection: false,
  // showHandler: true,
  setHeight: false
  // handlerConfig: { label: t('处理方式'), align: 'center' }
}

export const syncOrderReplenishStatus = [
  {
    name: t('待匹配'),
    value: 3
  },
  {
    name: t('在途'),
    value: 2
  },
  {
    name: t('匹配良品'),
    value: 1
  }
]

export const syncOrderGoodsStatus = [
  {
    name: t('待采购'),
    value: 0
  },
  {
    name: t('采购中'),
    value: 1
  },
  {
    name: t('已采购'),
    value: 2
  },
  {
    name: t('国内运输中'),
    value: 3
  },
  {
    name: t('已入库'),
    value: 4
  },
  {
    name: t('检品中'),
    value: 5
  },
  {
    name: t('已上架'),
    value: 6
  },
  {
    name: t('处理中的次品和异常'),
    value: 7
  },
  {
    name: t('不可退货次品'),
    value: 8
  },
  {
    name: t('取消成功'),
    value: 9
  }
]
